
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isTrainingOpen, setIsTrainingOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center space-x-3">
              {/* Airplane Logo */}
              <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center">
                <svg 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-white"
                >
                  <path 
                    d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" 
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-black" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Stiletto Airpark
              </h1>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link to="/" className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors">
                Home
              </Link>
              
              {/* Training Dropdown */}
              <div className="relative group">
                <button
                  onMouseEnter={() => setIsTrainingOpen(true)}
                  onMouseLeave={() => setIsTrainingOpen(false)}
                  className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors flex items-center cursor-pointer"
                >
                  Training
                  <i className="ri-arrow-down-s-line ml-1"></i>
                </button>
                
                {/* Invisible bridge to prevent dropdown from closing */}
                <div 
                  className="absolute top-full left-0 w-full h-2 bg-transparent"
                  onMouseEnter={() => setIsTrainingOpen(true)}
                  onMouseLeave={() => setIsTrainingOpen(false)}
                ></div>
                
                {isTrainingOpen && (
                  <div 
                    className="absolute top-full left-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-gray-200 z-50"
                    onMouseEnter={() => setIsTrainingOpen(true)}
                    onMouseLeave={() => setIsTrainingOpen(false)}
                  >
                    <div className="py-1">
                      <Link
                        to="/training/tailwheel-endorsement"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors"
                      >
                        Tailwheel Endorsement
                      </Link>
                      <Link
                        to="/training/sport-pilot"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors"
                      >
                        Sport Pilot License
                      </Link>
                      <Link
                        to="/training/private-pilot"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors"
                      >
                        Private Pilot License
                      </Link>
                    </div>
                  </div>
                )}
              </div>

              <Link to="/blog" className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors">
                Blog
              </Link>
              <Link to="/gallery" className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors">
                Our Fleet
              </Link>
              <Link to="/contact" className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors">
                Contact
              </Link>
              <a 
                href="tel:706-936-8961" 
                className="bg-teal-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Call Now
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-900 hover:text-teal-600 p-2 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <Link to="/" className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium">
                Home
              </Link>
              
              {/* Mobile Training Submenu */}
              <div className="pl-3">
                <div className="text-gray-700 px-3 py-2 text-base font-medium">Training</div>
                <Link to="/training/tailwheel-endorsement" className="text-gray-600 hover:text-teal-600 block px-6 py-1 text-sm">
                  Tailwheel Endorsement
                </Link>
                <Link to="/training/sport-pilot" className="text-gray-600 hover:text-teal-600 block px-6 py-1 text-sm">
                  Sport Pilot License
                </Link>
                <Link to="/training/private-pilot" className="text-gray-600 hover:text-teal-600 block px-6 py-1 text-sm">
                  Private Pilot License
                </Link>
              </div>
              
              <Link to="/blog" className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium">
                Blog
              </Link>
              <Link to="/gallery" className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium">
                Our Fleet
              </Link>
              <Link to="/contact" className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium">
                Contact
              </Link>
              <a 
                href="tel:706-936-8961" 
                className="bg-teal-600 text-white block px-3 py-2 rounded-md text-base font-medium hover:bg-teal-700 transition-colors cursor-pointer"
              >
                Call: 706-936-8961
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
